import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {notImplementedYet} from "../../../app.constants";
import {SharedCommonModule} from "../../../shared/commons/shared-common.module";
import {MenuStageService} from "../../../shared/commons/services/menu-stage.service";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-right-search',
  standalone: true,
  imports: [
    RouterLink,
    SharedCommonModule
  ],
  templateUrl: './right-search.component.html',
  styleUrl: './right-search.component.scss'
})
export class RightSearchComponent implements OnInit, OnDestroy {

  protected readonly notImplementedYet = notImplementedYet;
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  menuStageService = inject(MenuStageService);
  private thaiDWindow: Window | null = null;
  private thaiDWindowCheckInterval: any;
  handleThaiDMessage = (event: MessageEvent) => {
    if (event.data?.type == 'thaiD' && event.data?.payload) {
      console.log('Message from thaidWindow:', event.data);
      this.thaiDWindow.close();
      this.router.navigate(['thaid'], {relativeTo: this.activatedRoute, state: {pid: event.data.payload.pid}});
    }
  };

  ngOnInit(): void {
    this.menuStageService.setMenu("");
  }

  searchByName() {
    this.router.navigate(['name'], {state: undefined, relativeTo: this.activatedRoute});
  }

  authenThaiD() {
    this.thaiDWindow = window.open(`${environment.thaiDUrl}`, '_blank');
    window.addEventListener('message', this.handleThaiDMessage);
    this.thaiDWindowCheckInterval = setInterval(() => {
      if (this.thaiDWindow?.closed) {
        console.log('ThaiD window has been closed.');
        window.removeEventListener('message', this.handleThaiDMessage);
        clearInterval(this.thaiDWindowCheckInterval);
      }
    }, 1000); //
  }

  ngOnDestroy(): void {
    if (this.thaiDWindowCheckInterval) {
      clearInterval(this.thaiDWindowCheckInterval);
    }
    window.removeEventListener('message', (event) => this.handleThaiDMessage);
  }
}
